// extracted by mini-css-extract-plugin
export default {"page-name-wrapper":"PageName_page-name-wrapper__wkfPo","page-name":"PageName_page-name__HrypW","total-records":"PageName_total-records__UBVTc"};